import {Box, Card, Icon, Tab, Tabs} from "@mui/material";
import {useState} from "react";

export default function DetalhesOcorrenciaTabs({secoes = []}) {
    const secoesDisponiveis = secoes.filter((secao) =>
        Boolean(secao?.conteudo)
    );
    const [secaoSelecionada, setSecaoSelecionada] = useState(
        secoesDisponiveis[0]?.id || false
    );

    if (!secoesDisponiveis.length) {
        return null;
    }

    if (secoesDisponiveis.length === 1) {
        return secoesDisponiveis[0].conteudo;
    }

    const secaoAtiva = secoesDisponiveis.some(
        (secao) => secao.id === secaoSelecionada
    )
        ? secaoSelecionada
        : secoesDisponiveis[0].id;

    return (
        <Card variant="outlined" sx={{borderRadius: 2, overflow: "hidden"}}>
            <Box sx={{borderBottom: 1, borderColor: "divider"}}>
                <Tabs
                    value={secaoAtiva}
                    onChange={(_, valor) => setSecaoSelecionada(valor)}
                    variant="scrollable"
                    scrollButtons="auto"
                    allowScrollButtonsMobile
                    aria-label="Detalhes complementares da ocorrência"
                >
                    {secoesDisponiveis.map((secao) => (
                        <Tab
                            key={secao.id}
                            id={`aba-${secao.id}`}
                            aria-controls={`painel-${secao.id}`}
                            value={secao.id}
                            icon={<Icon fontSize="small">{secao.icone}</Icon>}
                            iconPosition="start"
                            label={secao.rotulo}
                            sx={{minHeight: 54}}
                        />
                    ))}
                </Tabs>
            </Box>

            {secoesDisponiveis.map((secao) => (
                <Box
                    key={secao.id}
                    id={`painel-${secao.id}`}
                    role="tabpanel"
                    aria-labelledby={`aba-${secao.id}`}
                    hidden={secaoAtiva !== secao.id}
                    p={{xs: 2, md: 2.5}}
                >
                    {secaoAtiva === secao.id ? secao.conteudo : null}
                </Box>
            ))}
        </Card>
    );
}
